import React from 'react'
import Header from './Header'
import Feedback from './Feedback'
import Figure1 from '../images/figure1.svg'
import Figure2 from '../images/figure2.svg'
import Figure4 from '../images/figure4.svg'
import Footer from './Footer'
import html2canvas from 'html2canvas'
import { storeUserInfo, addSubscriber } from '../utils/api'
import jsPDF from 'jspdf'

function Article({ post }){

  if(post == undefined)
  {
    return ''
  }
 return (

    <article>
      <h4
        dangerouslySetInnerHTML={{__html: post.title}}
      />
      <figure style={{backgroundImage: 'url(' + post.background_image +  ')'}}>

      </figure>

      <div className="information__bg">
        <p
          dangerouslySetInnerHTML={{__html: post.text}}
        />

        <div className="page-btns row">

          {
            post.buttons !== undefined &&
              post.buttons.map((res, i) => (
              <a key={i} href={res.button.url} className="page-btns__btn" target={res.button.target}>
                <span
                  dangerouslySetInnerHTML={{__html: res.button.title}}
                />
              </a>
            ))
          }

        </div>
      </div>
    </article>
  )
}

function getSuccesPosts({ checkedAnswers, completedQuiz, quizArray, scores}){
  let results = {};

  let posts = Object.keys(completedQuiz).map(function(key) {
      if(completedQuiz[key].status === true && key != '0'){
        let quiz = quizArray.find((res) => {

          return 'answer_' + res.id == key
        })

        if(quiz.acf.finish !== undefined){
          let sum = 0;
          let post_id = (key.split('_')[1])
          results[post_id] = {};
          Object.values(scores[key]).map((value, i) => {
            sum += value;

            results[post_id][i] = {question: quiz.acf.questions[i].question.question, answer: checkedAnswers['answer_' + post_id + '_' + i], score: value}
          })
          //const sum = Object.values(scores[key]).reduce((a, b) => a + b);
          quiz = quiz.acf.finish.post

          return quiz.find((res) => {
            return parseInt(res.minimum_score) <= sum && sum <= parseInt(res.maximum_score)
          })

        }
      }

    })

  return { results, posts }
}

export default class FinishPage extends React.Component{
  state = {
    userId: null,
    posts: [],
    results: null,
    subscriberEmail: null,
    submit: false
  }

  componentDidMount(){
    const { companyDetail, scores, checkedAnswers, quizArray, completedQuiz } = this.props;

    const { posts, results } = getSuccesPosts({ checkedAnswers, completedQuiz, quizArray, scores })

    this.setState({
      posts
    })

    storeUserInfo({ companyDetail, posts, scores, results }).then((user) => {

      this.setState({
        userId: user.id,

      })
    })

  }



  print(){
    window.print();
  }


  _exportPdf(rootElem) {


      html2canvas(rootElem,

        {
          allowTaint: true,
        }
        ).then(canvas => {



          var imgWidth = 210;
          var pageHeight = 295;

          let imgData = canvas.toDataURL("image/png");

          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight;

          var doc = new jsPDF('p', 'mm');
          var position = 0;

          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
          doc.save( 'file.pdf');
      });

  }

  handleEmailChange(e){
    this.setState({
      subscriberEmail: e.target.value
    })
  }

  handleSubmit(e){
    e.preventDefault();
    const { subscriberEmail } = this.state

    if(subscriberEmail){
      this.setState({
        submit: null
      })
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(subscriberEmail)) {
        this.setState({
          submit: 'error'
        })
        return
      }
      addSubscriber
      ({
        email: subscriberEmail
      })
      .then((res) => { 
        if(res.status){ 
          this.setState({
            submit: true
          })

        }else{
 
          this.setState({
            submit: 'error'
          })

        }

      })
    }else{
      this.setState({
        submit: 'error'
      })

    }

  }

  myRef = React.createRef(null);

  createRefToPdf = () => {

    const elements = this.myRef.current;
    this._exportPdf(elements);
  };


  render(){
    let { frontpageObject   } = this.props
    let { userId, posts, submit } = this.state






    return(

      <div className="wrap">
        <img src={Figure1} className="figure-abs1 figure-abs1_main"></img>
        <img src={Figure2} className="figure-abs2 figure-abs2_main"></img>
        <img src={Figure4} className="figure-abs4 figure-abs4_main"></img>

        {
        frontpageObject != undefined &&

          <div className="main">
            <Header  frontpageObject={frontpageObject}/>

            <section className="information">
              <div className="cont">
                <div className="page-head">
                  <div className="page-head__icon">
                      <img src={frontpageObject.acf.finish_page.image}  alt="company_info_svg" />
                    </div>

                    <h2 className="page-head__title"
                      dangerouslySetInnerHTML={{__html: frontpageObject.acf.finish_page.title}}
                    />
                </div>


                <div className="text-block information__text-block" ref={this.myRef}>

                  <h3
                    dangerouslySetInnerHTML={{__html: frontpageObject.acf.finish_page.sub_title}}
                  />

                  {posts !== undefined && posts.map((post, i) => <Article key={i} post={post} /> )}

                </div>

                <div className="information__info"
                  dangerouslySetInnerHTML={{__html: frontpageObject.acf.finish_page.footer_info}}
                />

                <div className="information__desc"
                  dangerouslySetInnerHTML={{__html: frontpageObject.acf.finish_page.footer_desc}}
                />
                <form action='' method='POST' id='subscription' onSubmit={(e) => this.handleSubmit(e)}>
                  <input onChange={(e) => this.handleEmailChange(e)} type='email' name="email" />
                  <button type='Submit' className='form-submit-btn'>שליחה</button>
                
                  {submit == 'error' && <span className='error_text notification'>כתובת המייל אינה תקינה</span>}
                  {submit == true && <span className='success notification'>פרטייך התקבלו בהצלחה</span>}
                  
                </form>
                <div className="page-btns-blue row">
                  <button  className="page-btns-blue__btn" onClick={this.print}>
                    <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.17" height="30.17" viewBox="0 0 30.17 30.17">
                        <path id="print-light" d="M24.513,18.856H5.657a1.886,1.886,0,0,0-1.886,1.886v7.543A1.886,1.886,0,0,0,5.657,30.17H24.513A1.886,1.886,0,0,0,26.4,28.284V20.742A1.884,1.884,0,0,0,24.513,18.856Zm0,9.428H5.657V20.742H24.513ZM26.4,11.314V4.162a1.887,1.887,0,0,0-.554-1.333L23.568.552A1.969,1.969,0,0,0,22.238,0H7.542A3.771,3.771,0,0,0,3.771,3.771v7.543A3.775,3.775,0,0,0,0,15.085v6.6a.943.943,0,1,0,1.886,0v-6.6A1.886,1.886,0,0,1,3.771,13.2H26.4a1.886,1.886,0,0,1,1.886,1.886v6.6a.943.943,0,1,0,1.886,0v-6.6A3.775,3.775,0,0,0,26.4,11.314Zm-1.886,0H5.657V3.771A1.886,1.886,0,0,1,7.542,1.886h14.7l2.275,2.276Zm.943,3.3a1.414,1.414,0,1,0,1.414,1.414A1.414,1.414,0,0,0,25.456,14.614Z"></path>
                      </svg>

                      <div
                        dangerouslySetInnerHTML={{__html: frontpageObject.acf.finish_page.print_button.text}}
                      />
                    </span>
                  </button>



                  <button className="page-btns-blue__btn" onClick={this.createRefToPdf} >
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22.621" height="30.167" viewBox="0 0 22.621 30.167">
                        <path id="file-pdf-light" d="M21.79,5.673,16.848.731a2.828,2.828,0,0,0-2-.831H2.828A2.837,2.837,0,0,0,0,2.733V27.239a2.828,2.828,0,0,0,2.828,2.828H19.793a2.828,2.828,0,0,0,2.828-2.828V7.676a2.841,2.841,0,0,0-.831-2ZM20.459,7.01a.927.927,0,0,1,.247.436H15.081V1.82a.927.927,0,0,1,.436.247Zm-.666,21.172H2.828a.945.945,0,0,1-.943-.943V2.733a.945.945,0,0,1,.943-.943H13.2V7.917a1.41,1.41,0,0,0,1.414,1.414h6.126V27.239A.945.945,0,0,1,19.793,28.182ZM18.5,18.1c-.8-.783-3.24-.542-4.342-.395A6.166,6.166,0,0,1,11.5,14.368c.253-1.06.707-2.78.377-3.823a1.378,1.378,0,0,0-2.627-.4c-.295,1.078-.018,2.616.495,4.583a56.713,56.713,0,0,1-2.48,5.219c-1.225.63-3.187,1.726-3.464,3.087-.206.99,1.349,2.321,3.128.377a15.763,15.763,0,0,0,1.844-2.68,34.245,34.245,0,0,1,4.83-1.414,8.987,8.987,0,0,0,3.805,1.172A1.428,1.428,0,0,0,18.5,18.1ZM5,23.34a8.228,8.228,0,0,1,2.091-2.4C5.785,23.016,5,23.381,5,23.34Zm5.608-13.1c.513,0,.459,2.209.124,2.8A5.724,5.724,0,0,1,10.6,10.244ZM8.931,19.628a27.632,27.632,0,0,0,1.7-3.752,7.674,7.674,0,0,0,2.068,2.445A21.534,21.534,0,0,0,8.931,19.628Zm9.037-.348s-.342.412-2.563-.536C17.82,18.568,18.214,19.122,17.967,19.281Z" transform="translate(0 0.1)"></path>
                      </svg>
                      <div
                        dangerouslySetInnerHTML={{__html: frontpageObject.acf.finish_page.download_button.text}}
                      />
                    </span>
                  </button>

                </div>

              </div>
            </section>
            <section className='feedback information__text-block'>
              <div className='information__bg'>
                <Feedback  frontpageObject={frontpageObject.acf.feedback} userId={userId} />
              </div>
            </section>

          </div>


        }
        <Footer />

     </div>
    )
  }
}
